const account_center = {
    /** UNTRANSLATED */
    not_enabled: 'Account center is not enabled.',
    /** UNTRANSLATED */
    filed_not_editable: 'Field is not editable.',
};
export default Object.freeze(account_center);
